import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';

import { SessionService } from './storage/session.service';
import { ApiService } from './api.service';

import { SessionStatus } from '../constants/session';
import { Contact, MemberContacts } from '../models/contacts';


const controllerRoute = '/contacts';

@Injectable()
export class ContactsService {

    public contancts: Contact[];

    public storageStore: Observable<any>;

    constructor(
        private apiService: ApiService,
        private sessionService: SessionService,
    ) {
        this.storageStore = this.sessionService.$SessionClear;
        this.storageStore.subscribe((status: string) => {
            switch (status) {
                case SessionStatus.clearSession:
                    this.contancts = null;
                    break;
            }
        });
    }

    public getContacts(): Observable<Contact[]> {
        if (this.contancts)
            return of(this.contancts);

        return this.apiService.get(`${controllerRoute}`).pipe(
            map((response: MemberContacts) => {
                this.contancts = response.memberContacts;
                return response.memberContacts;
            }),
        );
    }

}